import { atom } from "jotai";
import useHttp from "../hooks/useHttp";

export const brandCaliberSEOLoadingStatusAtom = atom("idle");
export const brandCaliberSEOAtom = atom(null);

export const fetchBrandCaliberSEOAtom = atom(
  null,
  async (get, set, brand, caliber) => {
    set(brandCaliberSEOLoadingStatusAtom, "loading");
    
    const { getBrandCaliberSEO } = useHttp();

    getBrandCaliberSEO(brand, caliber)
      .then((response) => set(brandCaliberSEOAtom, response.seo))
      .finally(() => set(brandCaliberSEOLoadingStatusAtom, "idle"));
  },
);
